import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fd2bb9da&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=fd2bb9da&prod&scoped=true&lang=less"
import style1 from "./index.vue?vue&type=style&index=1&id=fd2bb9da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2bb9da",
  null
  
)

export default component.exports